import { Injectable } from '@angular/core';
import { HttpService, LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { WebsitePageNamesEnum } from '../enums';
import { AppConfigService } from '@symphony-solo/domain/company-group/src';

@Injectable()
export class LoyaltyWebsiteService {
  constructor(private httpService: HttpService, private appConfigService: AppConfigService) {}

  public getWebsiteUrl(page: WebsitePageNamesEnum): Observable<LoyaltyResponse<string>> {
    return this.httpService.makeGet<LoyaltyResponse<string>>('website/createredirect/' + WebsitePageNamesEnum[page]);
  }

  public getPublicWebsiteUrl(page: WebsitePageNamesEnum): Observable<string> {
    const extraHeaders: { [name: string]: string } = {};
    let companyGUID = this.appConfigService.config?.companyGuid;
    if(this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    extraHeaders['CompanyGuid'] = companyGUID;
    return this.httpService.makeGet<string>('website/createopenredirect/' + WebsitePageNamesEnum[page], null, 'text', extraHeaders);
  }
}
